import classes from "./EventsPage.module.css";
import Events from "../components/events/Events";

export default function EventsPage() {
    return (
        <div>
            <p className={classes.sectionTitle}>UPCOMING EVENTS</p>
            <Events filter="upcoming" />
            <p className={classes.sectionTitlePast}>PAST EVENTS</p>
            <Events filter="past" />
        </div>
    );
}